export const featureWallList = [
    {
        title: "高性能",
        content: "依托tide.js渲染引擎，优化基础渲染性能和绘制性能，降低图形API的调用频率，提升CPU端的更新速度，减少drawcall的性能开销",
        link: '',
    },
    {
        title: "轻量化",
        content: "编辑器和渲染页资源分离，各个模块功能独立，代码体积小，业务可以按需加载基础渲染能力和所需要的api模块",
        link: '',
    },
    {
        title: "标准化",
        content: "对外提供规范丰富的api接口，提供完善的使用教程和api文档，致力打造简单易用的使用方式",
        link: '',
    },
    {
        title: "组件化",
        content: "基于sdk提供封装好的上层vue、react的ui组件库，方便前端快速开发（功能正在开发中，敬请期待）",
        link: '',
    },
  
]